import React, { useContext, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import MapContext from "../../MapContext";
import { Slider } from "@progress/kendo-react-inputs";
import { changeOpacity, getMapLayerById } from "../../utils/mapUtils";
import "./Layers.css";
import { Button } from "@progress/kendo-react-buttons";
import { setActiveLayer } from "../../../redux/optionsSlice";
import { updateLayerOpacity } from "../../../redux/setConfigSlice";

const LayerOptions = () => {
    const { map } = useContext(MapContext);
    const layerOptions = useSelector((state) => state.layerOptions);
    const layerVisProperties = useSelector(
        (state) => state.configData.layerVisProperties
    );
    const [mustTurnLayerOn, setMustTurnLayerOn] = useState(false);
    const dispatch = useDispatch();

    const layerProperties = layerVisProperties.find(
        (layer) => layer.Id === layerOptions.layerId
    );

    let opacityDebounce;
    const handleOpacityChange = (e) => {
        const opacity = e.value.toFixed() / 100;
        changeOpacity(map, layerOptions.layerId, opacity);
        clearTimeout(opacityDebounce);
        opacityDebounce = setTimeout(() => {
            dispatch(updateLayerOpacity([layerOptions.layerId, opacity]));
        }, 500);
    };

    const zoomToExtent = () => {
        const layer = getMapLayerById(map, layerOptions.layerId);
        let scale = 0;
        // For geojson layers with geostyler style with a max scaleDenominator
        if (layer.style_ && layer.style_.__geoStylerStyle) {
            layer.style_.__geoStylerStyle.rules.forEach((rule) => {
                if (
                    // if has field
                    rule.scaleDenominator &&
                    // if has max field
                    rule.scaleDenominator.max &&
                    // if is more than 0 or previously logged field
                    rule.scaleDenominator.max > scale
                ) {
                    scale = rule.scaleDenominator.max;
                }
            });
            const metersPerUnit_ = map.getView().getProjection().metersPerUnit_;

            //Correct scale (see sldHack in mapUtils)
            scale = metersPerUnit_ * scale;

            // Most people use .28 pixels/mm to derive dpi (equal 90.7)
            // Some layers weren't showing up using this value so 96 is used instead
            // See http://jsfiddle.net/sxfv3/
            const resolution = scale / (12 * 96);
            const zoom = map.getView().getZoomForResolution(resolution);
            const layerSource = layer.getSource().getExtent();
            const center = map.getView().getCenter(layerSource);
            map.getView().animate({ zoom: zoom }, { center: center });
        }
        // For geojsons with no max scaleDenominator
        // &&
        // For ArcGISImage layers
        if (scale === 0) {
            const source = layer.getSource();
            let extent;
            // For ArcGISImage Layers
            if (layer.state_.layer !== "VectorLayer") {
                // Can't get extent when image isn't visable
                if (source.image_ === null) {
                    // Displays text telling user to turn on images
                    setMustTurnLayerOn(true);
                }
                // Image is visible, get extent
                else {
                    extent = source.image_.extent;
                    map.getView().fit(extent);
                }
            }
            // For geojsons
            else {
                extent = layer.getSource().getExtent();
                map.getView().fit(extent);
            }
        }
    };

    return (
        <div className="layer-options" id="layer-options">
            <h3>{layerOptions.layerName}</h3>
            <Button
                icon="close"
                onClick={() =>
                    dispatch(setActiveLayer({ layerId: undefined, layerName: undefined }))
                }
                style={{ position: "absolute", right: "10px", top: "10px" }}
                fillMode="flat"
            />
            <div className="layer-option">
                <div>Transparency</div>
                <Slider
                    style={{ width: "8rem", marginLeft: "20px" }}
                    defaultValue={layerProperties.Opacity * 100}
                    min={1}
                    max={100}
                    onChange={handleOpacityChange}
                />
            </div>
            <div className="layer-option">
                <div>Zoom To Visible Extent</div>
                <Button
                    onClick={zoomToExtent}
                    style={{ marginLeft: "20px" }}
                    icon="zoom-best-fit"
                />
            </div>
            {mustTurnLayerOn ? (
                <i style={{ paddingLeft: "10px" }}>Turn image layer on to view extent</i>
            ) : (
                <div />
            )}
        </div>
    );
};

export default LayerOptions;
